var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isModalOpen(_vm.name))?_c('div',[_vm._t("default",null,{"modalName":_vm.name,"open":_vm.isModalOpen(_vm.name),"active":_vm.isModalActive(_vm.name),"data":_vm.getModalData(_vm.name),"activeId":_vm.getActiveModalId(_vm.name)})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }